<template>
  <v-app>
    <Header></Header>
    <Sidebar></Sidebar>
    <v-main class="content mx-0 mx-md-2">
      <router-view :key="$route.path"></router-view>
    </v-main>
  </v-app>
</template>
<script>
import Sidebar from "../../../../components/Sidebar/Sidebar";
import Header from "../../../../components/Header/Header";

export default {
  name: "TranslationLayout",
  components: {Header, Sidebar}
}
</script>
